"use client";

import { Home01Icon, Refresh01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import * as Sentry from "@sentry/nextjs";
import Link from "next/link";
import { useEffect } from "react";
import StatusPage from "@/components/routes/status-page";
import { Button } from "@/components/ui/button";

export default function ErrorPage({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useEffect(() => {
		Sentry.captureException(error);
		console.error(error);
	}, [error]);

	return (
		<StatusPage
			code="500"
			title="Something went wrong"
			description="An unexpected error interrupted this page. Please try again, or head back home and continue from there."
			actions={
				<>
					<Button
						variant="default"
						size="lg"
						onClick={() => reset()}
						className="w-full sm:w-auto"
					>
						<HugeiconsIcon icon={Refresh01Icon} className="mr-2 h-5 w-5" />
						Try again
					</Button>
					<Button
						variant="outline"
						size="lg"
						asChild
						className="w-full sm:w-auto"
					>
						<Link href="/">
							<HugeiconsIcon icon={Home01Icon} className="mr-2 h-5 w-5" />
							Back to home
						</Link>
					</Button>
				</>
			}
		/>
	);
}
